import {crisisManagers} from './tableModules/crisisManagers'
import {events} from './tableModules/events'
import {hiddenParticipants} from './tableModules/hiddenParticipants'
import {organisations} from "./tableModules/organisations"
import {participantGroups} from './tableModules/participantGroups'
import {participants} from './tableModules/participants'
import {sets} from './tableModules/sets'
import {users} from './tableModules/users'
import {amoswebLogs} from "~/utils/tableModules/amoswebLogs"
import {billingRuns} from "~/utils/tableModules/billingRuns"
import {billings} from "~/utils/tableModules/billings"
import {mailTemplates} from "~/utils/tableModules/mailTemplates"
import {mails} from "~/utils/tableModules/mails"

export const tableModules: TableModules = {
    users,
    organisationUsers: {
        ...users,
        name: 'organisationUsers',
        route: 'spa.system.organisations.users',
        routeParams: [{
            param: "organisation",
            prop: "organisation_id"
        }],
    },
    internalUsers: {
        ...users,
        name: 'internalUsers',
        route: 'spa.internal.organisation.users'
    },
    organisations,
    testUsers: {
        ...users,
        name: 'testUsers'
    } as TableModule,
    billings,
    billingRuns,
    organisationBillings: {
        ...billings,
        name: 'organisationBillings',
        route: 'spa.system.organisations.billings',
        columns: billings.columns.filter(column => column.name !== 'organisation_name'),
        routeParams: [{
            param: "organisation",
            prop: "organisation_id"
        }],
    },
    internalBillings: {
        ...billings,
        name: 'internalBillings',
        route: 'spa.internal.organisation.billings',
        columns: billings.columns.filter(column => column.name !== 'organisation_name'),
    },
    organisationMailTemplates: {
        ...mailTemplates,
        route: 'spa.system.organisations.mailTemplates',
        routeParams: [{
            param: "organisation",
            prop: "organisation_id"
        }],
        quickFilters: []
    } as TableModule,
    internalMailTemplates: {
        ...mailTemplates,
        route: 'spa.internal.organisation.mailTemplates',
        quickFilters: []
    } as TableModule,
    mailTemplates,
    mails,
    sets,
    events,
    amoswebLogs,
    participants,
    participantGroups,
    // The members of one group, read-only — assignment stays on the participants table with its selection tools.
    groupParticipants: {
        ...participants,
        name: 'groupParticipants',
        route: 'spa.events.events.participantGroups.participants',
        routeParams: [
            {param: "event", prop: "event_id"},
            {param: "participantGroup", prop: "participantGroup"}
        ],
        tools: [],
        columns: [
            {name: "name", mobile: true, truncate: false, pageLink: true},
            {name: "participantGroups", truncate: false},
            {name: "communications", breakpoint: 'md'},
            {name: "status", width: 'w-[220px]', truncate: false, mobile: true}
        ]
    } as TableModule,
    externalParticipants: {
        ...participants,
        name: 'externalParticipants',
        route: 'spa.external.events.participants',
        routeParams: [{
            param: "event",
            prop: "event_id"
        }],
        columns: [
            {
                name: "name",
                mobile: true,
                truncate: false,
                pageLink: true
            },
            {
                name: "gender",
                truncate: false,
                sortable: true,
                width: 'w-[120px]',
                breakpoint: 'lg'
            },
            {
                name: "address",
                sortable: true,
                sortBy: "participants.zip",
            },
            {
                name: "communications",
                breakpoint: 'md'
            },
            {
                name: "status",
                width: 'w-[125px]',
                truncate: false,
                mobile: true,
            }
        ],
    },
    hiddenParticipants,
    crisisManagers,
    crisisManagerEvents: {
        ...events,
        name: 'crisisManagerEvents',
        tools: [],
    }
}
